import { all } from "redux-saga/effects";
import { photoSaga } from "./slice/images/images.saga.js";
import { eventsSaga } from "./slice/events/events.saga.js";
import authSaga from "./slice/auth/auth.saga.js";

export function* rootSaga() {
  yield all([photoSaga(), eventsSaga(), authSaga()]);
}